import { IdvPreference } from "@amzn/client-workbench-api-model";
import { useContext } from "react";
import { useQuery, UseQueryResult } from "react-query";

import { getIdvPreference } from "@/apis/IVVHelper";
import { getRetryDelayMs, shouldRetry } from "@/helpers/react-query-helper";
import { AppContext } from "@/stores/appStore";

/**
 * Hook to get user metadata
 */
export const useGetIdvPreference = (): UseQueryResult<IdvPreference> => {
  const { state } = useContext(AppContext);

  return useQuery("getIdvPreference", getIdvPreference, {
    enabled: state.amplifyConfigured,
    retry: (failureCount, err) => shouldRetry(failureCount, err),
    retryDelay: (retryCount) => getRetryDelayMs(retryCount),
  });
};
